// extracted by mini-css-extract-plugin
export default {"headerText":"LatestNews_headerText__CY-9b","headerTextMobile":"LatestNews_headerTextMobile__Pbhzc","wrapperTitle":"LatestNews_wrapperTitle__4Nty4"};